import React from 'react'
import {Link} from 'react-router-dom'
import Logo from '../assets/icons/logo.png'

function Header(){
    return (
        <nav className="navbar" role="navigation" aria-label="main navigation">
            <div className="navbar-brand">
                <Link to="/home" className="p-4">
                    <img src={Logo} alt="logo" width="120" />
                </Link>
            </div>
        </nav>
    )
}

export default Header